var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144.773 144.773",
    style: {
      enableBackground: "new 0 0 144.773 144.773"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A6D9EA"
    },
    cx: 72.387,
    cy: 72.386,
    r: 72.386
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 72.387,
    cy: 72.386,
    r: 72.386
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#471B18"
    },
    d: "M73.415,33.032c0,0-10.129-2.383-18.766,4.169c-8.637,6.553-4.051,15.877-12.391,23.323 C33.92,67.97,35.11,74.67,39.727,82.86c4.615,8.19-5.82,12.018-2.877,22.013c2.854,9.688,13.002,14.643,13.002,14.643H95.27 c0,0,14.645-10.828,15.389-18.72c0.744-7.893-7.492-11.823-5.109-17.333c2.381-5.51,2.553-13.238-2.926-19.28 c-6.754-7.446-1.523-9-6.609-19.294C90.145,33.01,81.6,30.433,73.415,33.032z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M107.053,116.94c-4.666-8.833-34.666-14.376-34.666-14.376s-30,5.543-34.666,14.376 c-3.449,12.258-6.334,27.833-6.334,27.833h41h41C113.387,144.773,111.438,128.073,107.053,116.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M72.387,102.564c0,0,30,5.543,34.666,14.376c4.385,11.133,6.334,27.833,6.334,27.833h-41V102.564 z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.219,
    y: 84.606,
    style: {
      fill: "#F1C9A5"
    },
    width: 16.334,
    height: 27.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.387,
    y: 84.606,
    style: {
      fill: "#E4B692"
    },
    width: 8.166,
    height: 27.336
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#DDAC8C"
    },
    d: "M64.219,97.273c1.469,4.217,7.398,6.634,11.752,6.634 c1.574,0,3.108-0.264,4.582-0.747V84.606H64.219V97.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M93.387,67.357c0-17.074-9.402-26.783-21-26.783c-11.598,0-21,9.709-21,26.783 s9.402,30.917,21,30.917C83.985,98.274,93.387,84.432,93.387,67.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M90.19,79.195c-3.807-0.424-6.377-4.783-5.732-9.732c0.637-4.953,4.242-8.63,8.051-8.209 c3.805,0.422,6.371,4.779,5.729,9.732C97.598,75.939,93.997,79.613,90.19,79.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M46.684,70.986c-0.643-4.953,1.924-9.311,5.727-9.732c3.81-0.421,7.416,3.256,8.055,8.209 c0.643,4.949-1.93,9.309-5.734,9.732C50.924,79.613,47.323,75.939,46.684,70.986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M93.387,67.357c0-17.074-9.402-26.783-21-26.783v57.7C83.985,98.274,93.387,84.432,93.387,67.357 z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "46.895,144.773 72.387,144.773 97.774,144.773 97.774,117.205 46.895,117.205  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE393E"
    },
    d: "M67.459,144.773l-4.744-40.007c-10.615,1.666-22.643,7.719-24.994,12.174 c-3.449,12.258-6.334,27.833-6.334,27.833H67.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE393E"
    },
    d: "M79.336,144.773h34.051c0,0-1.949-16.7-6.334-27.833c-3.828-6.82-18.959-10.514-24.232-12.067 L79.336,144.773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#471B18"
    },
    d: "M72.334,49.683c0,0-4.525,9.762-10.9,12.833c-10.047,4.842-1.33,12.234-2.5,22.091 c-1.055,8.893-11.385,12.951-5.359,22.514c-10.475,2.063-9.975-3.213-9.975-3.213s-1-27.465-1.25-28.095 c-0.25-0.63,6-17.63,6-17.63l8.988-19.25l16.076-3.253L72.334,49.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#471B18"
    },
    d: "M72.334,49.683c0,0,0.506,7.666,8.219,8.333c7.715,0.667,8.715,6.318,7.215,11.409 c-1.5,5.091-2.168,7.925,2,11.925c4.166,4-0.5,19.446-0.5,19.446l15.334-7.297c0,0-3.271-12.403-1.5-19.316 S96.934,62.35,94.934,57.35S82.893,34.31,74.768,35.68c-8.127,1.37-7.309,10.003-7.309,10.003L72.334,49.683z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarF);
export default __webpack_public_path__ + "static/media/avatar-F.808316712528b017c1b86dfc0bc3f922.svg";
export { ForwardRef as ReactComponent };